// Site-wide visitor tracking — fire-and-forget POST to api/track.php.
// Browser/OS are parsed server-side from the User-Agent header; screen size,
// viewport, timezone and language are supplied here because a server can
// never see those from the User-Agent alone.
//
// Never throws, never blocks navigation, never shows up to the visitor —
// see api/track.php, which always responds 200 regardless of outcome.

const API_BASE = process.env.REACT_APP_API_BASE || "https://rashiddev.in/api";

function getClientToken() {
  try {
    return localStorage.getItem("rd_client_token") || null;
  } catch (_) {
    return null;
  }
}

export function trackPageView(path, event = "page_view") {
  try {
    const payload = {
      event,
      path: path || (typeof window !== "undefined" ? window.location.pathname : ""),
      referrer: typeof document !== "undefined" ? document.referrer : "",
      client_token: getClientToken(),
      screen_w: window.screen?.width,
      screen_h: window.screen?.height,
      viewport_w: window.innerWidth,
      viewport_h: window.innerHeight,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      language: navigator.language,
    };

    const body = JSON.stringify(payload);
    // sendBeacon survives page unload (e.g. tracking the outgoing page on a
    // fast route change) and doesn't block anything; fall back to a plain
    // fire-and-forget fetch where it's unavailable.
    if (navigator.sendBeacon) {
      const blob = new Blob([body], {type: "application/json"});
      navigator.sendBeacon(`${API_BASE}/track.php`, blob);
    } else {
      fetch(`${API_BASE}/track.php`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch (_) {
    // Analytics must never break navigation.
  }
}
